<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <vs-table
          :max-items="descriptionItems[0]"
          pagination
          :data="items"
          description
          search
          @selected="openViewData"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.Items") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                @click="$router.push({ name: 'Create Item' })"
                size="small"
                >{{ $t("setup.label.CreateItem") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.Id") }}</vs-th>
            <vs-th>{{ $t("setup.label.ItemCode") }}</vs-th>
            <vs-th>{{ $t("setup.label.ItemDescription") }}</vs-th>
            <vs-th>{{ $t("setup.label.Units") }}</vs-th>
            <vs-th>{{ $t("setup.label.Total") }}</vs-th>
            <vs-th>{{ $t("setup.label.Warranty") }}</vs-th>
            <vs-th>{{ $t("setup.label.UsedItems") }}</vs-th>
            <vs-th>{{ $t("setup.label.Balanced") }}</vs-th>
            <vs-th>{{ $t("setup.label.IsProvisioning") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="item" v-for="(item, index) in data">
              <vs-td :data="item.id">{{ item.id }}</vs-td>
              <vs-td :data="item.itemCode">{{ item.itemCode }}</vs-td>
              <vs-td :data="item.itemDescription">{{
                item.itemDescription
              }}</vs-td>
              <vs-td :data="item.units">{{ item.units }}</vs-td>
              <vs-td :data="item.totalItems">{{ item.totalItems }}</vs-td>
              <vs-td :data="item.warranty">{{ item.warranty }}</vs-td>
              <vs-td :data="item.usedItems">{{ item.usedItems }}</vs-td>
              <vs-td :data="item.availableItems">{{
                item.availableItems
              }}</vs-td>
              <vs-td :data="item.isProvisioning">{{
                item.isProvisioning
              }}</vs-td>

              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('inventory.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editData(item.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('inventory.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deleteItemPopup = true;
                      delId = item.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('inventory.label.DeleteItem')"
          :active.sync="deleteItemPopup"
          class="popup-close small-popup"
        >
          <div class="center">
            <img src="@/assets/images/pages/delete.svg" />
            <div class="success-msg">
              {{ $t("system.label.areYouSureDelete") }}
            </div>
          </div>

          <div class="center">
            <span class="p-2">
              <vs-button type="border" @click="deleteItemPopup = false">{{
                $t("system.label.cancel")
              }}</vs-button></span
            >

            <span class="p-2">
              <vs-button @click="removeItem(delId)">{{
                $t("setup.label.Ok")
              }}</vs-button>
            </span>
          </div>
          <div style="height: 20px"></div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      descriptionItems: [5, 10, 15],
      deleteItemPopup: false,
      delId: null,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      items: (state) => state.items.itemList,
    }),
  },
  methods: {
    async getItemList() {
      this.loading = true;
      try {
        await this.$store.dispatch("items/setItemList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    editData(id) {
      this.$router.push({ name: "Edit Item", params: { id: id } });
    },
    async removeItem(id) {
      try {
        await this.$store.dispatch("items/deleteItemAction", id);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Item Successfully Deleted",
          type: "success",
        });
        this.deleteItemPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    openViewData(item) {
      this.$router.push({ name: "View Item", params: { id: item.id } });
    },
  },
  created() {
    this.getItemList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}
.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}
.vs-search-categeory {
  margin-top: 17px;
}
</style>
